<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">
          <el-form-item class="fn-left">
            <wq-select :selected.sync="listQuery.status" placeholder="请选择状态" value-name="id" text-name="name" :columns="statusMap" />
          </el-form-item>
          <el-form-item class="fn-left">
            <wq-select :selected.sync="listQuery.type" placeholder="请选择状态" value-name="id" text-name="name" :data-func="$http.getSuggestionType" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="$refs['goldoptionslisttable'].fetchTableData() ">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="goldoptionslisttable" show-page sub-key="list" :other-query="listQuery" :url-func="$http.getSuggestionList">
        <el-table-column label="创建时间" prop="create_time" align="center" />
        <el-table-column label="店铺" prop="shop_name" align="center" />
        <el-table-column label="提交人" prop="teacher_name" align="center" />
        <el-table-column label="类型" prop="type_name" align="center" />
        <el-table-column label="内容" prop="suggestion" align="center" />
        <el-table-column label="图片" align="center" width="150px">
          <template slot-scope="{row}">
            <div v-if="row.imgs && row.imgs.length > 0 && row.imgs != '[]'">
              <el-image v-for="(item,index) in row.imgs" :key="item" style="height: 50px;margin-right: 5px;" :initial-index="index" :preview-src-list="row.imgs" :src="item" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220px">
          <template slot-scope="{row}">
            <el-button v-if="row.status == 0" type="primary" size="small" @click="fnReply(row)">回复</el-button>
            <span v-if="row.status == 1">已处理</span>
          </template>
        </el-table-column>
      </wq-table>

    </div>
    <el-dialog
      title="回复"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <form-box ref="replyForms" key="replyForms" label-width="120px" :forms="replyForms" :post-form="replyPostForm" @submit="fnUpdateReplySubmit" />
    </el-dialog>
  </div>

</template>
<script>

const defaultReplyPostForm = {
  id: '',
  content: ''

}
import WqTable from '@/components/WqTable'
import WqSelect from '@/components/FormBox/WqSelect'
import FormBox from '@/components/FormBox'
export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable,
    WqSelect,
    FormBox
  },

  data() {
    return {
      lists: [],
      listQuery: {
        status: 0,
        type: ''
      },
      statusMap: [{
        id: 0,
        name: '未处理'
      }, {
        id: 1,
        name: '已处理'
      }],
      replyForms: [
        { type: 'textarea', label: '内容', bindValue: 'content', require: true }
      ],
      replyPostForm: Object.assign({}, defaultReplyPostForm),
      statusLists: [{ id: 1, name: '未收货' }, { id: 2, name: '已收货' }],
      auditMessage: '',
      dialogVisible: false,
      currentAudit: {
        note_id: '',
        result: '',
        comment: ''
      },
      expressLists: [],
      tableKey: 0
    }
  },
  created() {
    this.fnGetExpressLists()
  },
  methods: {
    fnGetExpressLists() {
      this.$http.notHaveExpressInfoPackageList().then((res) => {
        if (res.code == 200) {
          this.expressLists = this.fnConvertObjectToArray(res.data.express_list)
        }
      })
    },
    fnConvertObjectToArray(objs) {
      const ary = []
      for (const key in objs) {
        ary.push({ value: key, label: objs[key] })
      }
      return ary
    },
    fnReply(row) {
      this.replyPostForm = Object.assign({}, defaultReplyPostForm, { id: row.id })
      this.dialogVisible = true
    },
    fnUpdateReplySubmit(postForm) {
      this.$http.replySuggestion(postForm).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '回复成功!' })
          this.dialogVisible = false
          this.$refs['goldoptionslisttable'].fetchTableData()
        }
      })
    }
  }
}
</script>
  <style lang="scss">
  .el-image-viewer__wrapper .el-icon-circle-close {
    color:white
  }
    .food-search {
    .tuolele-main-search-item {
      margin-bottom: 0;
      padding: 0;
      border: 0;
      .el-form--inline .el-form-item {
        display: block;
      }
      .split-time{
        margin-right: 20px;
      }
      .el-select,
      .el-input {
        width: 160px !important;
        margin-right: 20px;
      }
      span.select-date {
        margin-right: 10px;
      }
      .button-group {
        margin-left: 82px;
      }
    }
  }
  </style>
